import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import HFOptionGroup from 'components/HFInputs/HFOptionGroup'

import styles from '../../controllers/Dialog.module.sass'
import HFTextInput from 'components/HFInputs/HFTextInput'
import {
	booleanOptions,
	validationOptions,
} from 'controllers/TaskManager/formOptions'
import { useFormContext } from 'react-hook-form'
import { useContext } from 'react'
import { ForwardingTaskContext } from 'context/ForwardingTask/ForwardingTaskContext'
import HFValidatePostalCodeInput from 'components/HFInputs/HFValidatePostalCodeInput'
import HFDatepicker from 'components/HFInputs/HFDatepicker'

export const ForwardingTaskDataValidationController = () => {
	const { i18n } = useGlobal()
	const { watch } = useFormContext()
	const { injured, accident } = useContext(ForwardingTaskContext)

	const [
		dataValidationName,
		dataValidationBirthDate,
		dataValidationAccidentDate,
	] = watch([
		'dataValidation.injuredNameValidation',
		'dataValidation.birthDateValidation',
		'dataValidation.accidentDateValidation',
	])

	return (
		<fieldset>
			<VStack className={styles['option-group-list']}>
				<HFOptionGroup
					className={`${styles['option-group']} ${styles['--horizontal-flex']}`}
					name='dataValidation.injuredNameValidation'
					type='boolean'
					customLabel={{
						label: i18n`Name`,
						value: injured?.name || i18n`Missing`,
					}}
					options={validationOptions}
				/>

				{dataValidationName !== undefined && !dataValidationName ? (
					<VStack className={styles['form-input']}>
						<h5>{i18n`Name provided by injured`}</h5>
						<HFTextInput
							name='dataValidation.providedInjuredName'
							multiline={false}
							rows={5}
							noResize
						/>
					</VStack>
				) : null}

				<VStack className={styles['form-input']}>
					<h5>{i18n`Is call recording authorized?`}</h5>
					<HFOptionGroup
						className={`${styles['option-group']} ${styles['--horizontal-flex']}`}
						name='contact.authorizeRecording'
						type='boolean'
						options={booleanOptions}
					/>
				</VStack>

				<HFOptionGroup
					className={`${styles['option-group']} ${styles['--horizontal-flex']}`}
					name='dataValidation.birthDateValidation'
					type='boolean'
					customLabel={{
						label: i18n`Birthday date`,
						value: injured?.birthday || i18n`Missing`,
					}}
					options={validationOptions}
				/>

				{dataValidationBirthDate !== undefined &&
				!dataValidationBirthDate ? (
					<VStack className={styles['form-input']}>
						<h5>{i18n`Birthday date provided by injured`}</h5>
						<HFDatepicker
							name='dataValidation.providedBirthDate'
							type='date'
						/>
					</VStack>
				) : null}

				<VStack className={styles['form-input']}>
					<h5>{i18n`Postal code`}</h5>
					<HFValidatePostalCodeInput
						name='dataValidation.postalCode'
						type='text'
						inputMask='9999-999'
						placeholder='____-___'
					/>
				</VStack>

				<VStack className={styles['form-input']}>
					<h5>{i18n`Injured Email`}</h5>
					<HFTextInput
						name='dataValidation.email'
						multiline={false}
						rows={5}
						noResize
					/>
				</VStack>

				<VStack className={styles['form-input']}>
					<h5>{i18n`NIF`}</h5>
					<HFTextInput
						name='dataValidation.nif'
						multiline={false}
						type='number'
						rows={5}
						noResize
					/>
				</VStack>

				<HFOptionGroup
					className={`${styles['option-group']} ${styles['--horizontal-flex']}`}
					name='dataValidation.accidentDateValidation'
					type='boolean'
					customLabel={{
						label: i18n`Accident Date`,
						value: accident?.date?.shortDateFormat || i18n`Missing`,
					}}
					options={validationOptions}
				/>

				{dataValidationAccidentDate !== undefined &&
				!dataValidationAccidentDate ? (
					<VStack className={styles['form-input']}>
						<h5>{i18n`Accident date provided by injured`}</h5>
						<HFDatepicker
							name='dataValidation.providedAccidentDate'
							type='date'
						/>
					</VStack>
				) : null}
			</VStack>
		</fieldset>
	)
}
